import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        warning: {
            fontSize: '12px',
            paddingTop: '5px',
            fontStyle: 'italic',
            color: '#828282',
            '& span': { paddingRight: '5px', color: 'red' },
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            marginBottom: 2
        },
        titleEvidences: {
            fontSize: '16px',
            color: colors.color13,
            fontWeight: '600',
        },
        warningIcon: {
            color: colors.color19,
            width: '40px',
            height: '40px',
            '& .MuiSvgIcon-root': {
                fontSize: '40px',
            },
        },
    }
}

export { useStyles }
